import { useTranslation } from 'react-i18next';
import { ExoVariants } from '../exo/ExoVariants';
import BallotIcon from '@mui/icons-material/Ballot';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SelectOffer from './SelectOffer';
import SelectOrder from './SelectOrder';
import SelectInvoice from './SelectInvoice';
import SelectDeliveryNote from './SelectDeliveryNote';
import { API_GET, DBRequest, useConfig } from '../../api/api';
import { useState } from 'react';
import SelectPositions from './SelectPositions';
import { Box, Button } from '@mui/material';

export const SelectImportPositions = ({ onSubmit }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const [selectedPositions, setSelectedPositions] = useState(null);
  const [positionsToSubmit, setPositionsToSubmit] = useState(null);

  const variants = [
    {
      label: t('Offer'),
      Icon: DescriptionIcon,
      content: (
        <SelectOffer
          useSearch
          onSelect={(data) => handleSelect(data, 'offers')}
        />
      ),
    },
    {
      label: t('Order'),
      Icon: BallotIcon,
      content: (
        <SelectOrder onSelect={(data) => handleSelect(data, 'orders')} />
      ),
    },
    {
      label: t('Invoice'),
      Icon: ReceiptIcon,
      content: (
        <SelectInvoice onSelect={(data) => handleSelect(data, 'invoices')} />
      ),
    },
    {
      label: t('Delivery Note'),
      Icon: LocalShippingIcon,
      content: (
        <SelectDeliveryNote
          onSelect={(data) => handleSelect(data, 'delivery-notes')}
        />
      ),
    },
  ];

  function handleSelect(data, type) {
    DBRequest({
      config,
      path: `${type}/${data.id}`,
      method: API_GET,
      onResponse: (res) => setSelectedPositions(res.data.positions),
    });
  }

  function handleRemove(item, allItems) {
    if (item.isGroup) {
      return handleGroupRemove(item, allItems);
    } else {
      const newItems = allItems.filter((el) => el.id != item.id);
      return newItems;
    }
  }

  function handleGroupRemove(item, allItems) {
    let newItems = allItems;

    const index = allItems.findIndex((el) => el.id == item.id);

    let groupKeys = [item.id];
    let counter = 1;
    while (
      index + counter < allItems.length &&
      allItems[index + counter].depth > allItems[index].depth
    ) {
      groupKeys.push(allItems[index + counter].id);
      counter++;
    }

    newItems = newItems.map((el) => {
      return groupKeys.includes(el.id) ? { ...el, depth: el.depth - 1 } : el;
    });
    newItems = newItems.filter((el) => el.id != item.id);

    return newItems;
  }

  function handleSubmit(positions) {
    const positionIds = positions.map((el) => el.id);

    let allPositions = [...selectedPositions];

    for (let i = 0; i < selectedPositions.length; i++) {
      const currentPos = selectedPositions[i];

      if (positionIds.includes(currentPos.id)) {
        continue;
      } else {
        allPositions = handleRemove(currentPos, allPositions);
      }
    }

    onSubmit(allPositions);
  }

  return (
    <>
      {selectedPositions ? (
        <Box className="flex flex-col items-end gap-3 pb-3">
          <SelectPositions
            allowAll
            //requirePercent
            unrestrictedSelect={true}
            positions={selectedPositions}
            onSelect={setPositionsToSubmit}
            removeIds
          />
          <Button
            variant="contained"
            color="success"
            onClick={() => handleSubmit(positionsToSubmit)}
          >
            {t('Confirm')}
          </Button>
        </Box>
      ) : (
        <ExoVariants variants={variants} />
      )}
    </>
  );
};
